// 修改默认头像常量
const DEFAULT_AVATAR = '/images/profile.png';  // 使用profile.png作为默认头像

const AUTH_KEY = 'hugtub_auth';
const USERS_KEY = 'hugtub_users';
const DEVICE_KEY = 'hugtub_device_id';  // 添加设备ID的key

const generateUserId = () => {
  // 生成10位随机数字
  let id = '';
  // 第一位不能为0
  id += Math.floor(Math.random() * 9 + 1);
  // 生成剩余9位数字
  for (let i = 1; i < 10; i++) {
    id += Math.floor(Math.random() * 10);
  }
  return id;
};

const validateUsername = (username, users) => {
  // 检查用户名是否已存在
  if (users.some(u => u.username === username)) {
    throw new Error('用户名已被使用');
  }
  
  // 可以添加其他用户名验证规则
  if (username.length < 3) {
    throw new Error('用户名至少需要3个字符');
  }
  
  if (username.length > 20) {
    throw new Error('用户名最多20个字符');
  }
  
  // 只允许字母、数字、下划线
  if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]+$/.test(username)) {
    throw new Error('用户名只能包含字母、数字、下划线和中文');
  }
};

const validatePassword = (password) => {
  // 至少8位，包含大写字母和数字
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const isLongEnough = password.length >= 8;

  if (!hasUpperCase) throw new Error('密码必须包含至少一个大写字母');
  if (!hasNumber) throw new Error('密码必须包含至少一个数字');
  if (!isLongEnough) throw new Error('密码长度至少为8位');
};

// 生成或获取设备ID
const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_KEY);
  if (!deviceId) {
    deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(DEVICE_KEY, deviceId);
  }
  return deviceId;
};



// 存储验证码的对象，键为手机号，值为{code, expiry}对象
const verificationCodes = {};

// 生成随机验证码
const generateVerificationCode = () => {
  // 生成6位随机数字
  return Math.floor(100000 + Math.random() * 900000).toString();
};

// 验证手机号格式
const validatePhone = (phone) => {
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!phoneRegex.test(phone)) {
    throw new Error('请输入有效的手机号码');
  }
};

export const authService = {
  register: (username, password) => {
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const deviceId = getDeviceId();
    
    // 检查此设备是否已注册账号
    if (users.some(u => u.deviceId === deviceId)) {
      throw new Error('每个设备只能注册一个账号');
    }
    
    // 验证用户名和密码
    validateUsername(username, users);
    validatePassword(password);

    let newId;
    do {
      newId = generateUserId();
    } while (users.some(user => user.id === newId));

    const newUser = {
      id: newId,
      username,
      password,
      avatar: DEFAULT_AVATAR,  // 使用本地默认头像
      exp: 0,
      deviceId,
      birthday: '',
      bio: '',
      mbti: ''
    };

    users.push(newUser);
    localStorage.setItem(USERS_KEY, JSON.stringify(users));

    const authData = {
      id: newUser.id,
      username: newUser.username,
      avatar: newUser.avatar,
      exp: newUser.exp,
      isLoggedIn: true
    };
    localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    return authData;
  },

  login: (username, password) => {
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const user = users.find(u => u.username === username && u.password === password);
    
    if (!user) {
      throw new Error('用户名或密码错误');
    }



    const authData = {
      id: user.id,
      username: user.username,
      avatar: user.avatar,
      exp: user.exp,
      birthday: user.birthday || '',
      bio: user.bio || '',
      mbti: user.mbti || '',
      isLoggedIn: true
    };
    localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    return authData;
  },

  updateProfile: (userId, updates) => {
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const userIndex = users.findIndex(u => u.id === userId);
    
    if (userIndex === -1) {
      throw new Error('用户不存在');
    }

    const updatedUser = {
      ...users[userIndex],
      ...updates,
      avatar: updates.avatar || DEFAULT_AVATAR,  // 如果没有新头像，使用默认头像
      exp: updates.exp || users[userIndex].exp || 0
    };

    users[userIndex] = updatedUser;
    localStorage.setItem(USERS_KEY, JSON.stringify(users));

    const authData = {
      id: updatedUser.id,
      username: updatedUser.username,
      avatar: updatedUser.avatar,
      exp: updatedUser.exp,
      birthday: updatedUser.birthday || '',
      bio: updatedUser.bio || '',
      mbti: updatedUser.mbti || '',
      isLoggedIn: true
    };
    localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    return authData;
  },

  logout: () => {
    localStorage.removeItem(AUTH_KEY);
  },

  getCurrentUser: () => {
    const authData = localStorage.getItem(AUTH_KEY);
    if (!authData) return null;

    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const currentUser = JSON.parse(authData);
    const user = users.find(u => u.id === currentUser.id);

    if (!user) return null;

    return {
      id: user.id,
      username: user.username,
      avatar: user.avatar,
      exp: user.exp || 0,
      birthday: user.birthday || '',
      bio: user.bio || '',
      mbti: user.mbti || '',
      isLoggedIn: true
    };
  },
  
  // 发送验证码
  sendVerificationCode: (phone) => {
    // 验证手机号格式
    validatePhone(phone);
    
    // 生成验证码
    const code = generateVerificationCode();
    // 设置过期时间为10分钟后
    const expiry = Date.now() + 10 * 60 * 1000;
    
    // 存储验证码和过期时间
    verificationCodes[phone] = { code, expiry };
    
    // 这里应该调用短信服务API发送验证码
    // 例如：调用阿里云、腾讯云等短信服务
    console.log(`向手机号 ${phone} 发送验证码: ${code}`);
    
    // 在实际应用中，这里应该返回一个Promise，表示短信发送的结果
    // 由于这是前端模拟，我们直接返回成功
    return Promise.resolve();
  },
  
  // 使用手机号和验证码登录
  loginWithPhone: (phone, code) => {
    // 验证手机号格式
    validatePhone(phone);
    
    // 检查验证码是否存在且未过期
    const verification = verificationCodes[phone];
    if (!verification) {
      throw new Error('验证码不存在或已过期，请重新获取');
    }
    
    if (Date.now() > verification.expiry) {
      // 删除过期的验证码
      delete verificationCodes[phone];
      throw new Error('验证码已过期，请重新获取');
    }
    
    if (verification.code !== code) {
      throw new Error('验证码错误');
    }
    
    // 验证通过，删除验证码
    delete verificationCodes[phone];
    
    // 检查用户是否存在，如果不存在则创建新用户
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    let user = users.find(u => u.phone === phone);
    
    if (!user) {
      // 创建新用户
      const deviceId = getDeviceId();
      let newId;
      do {
        newId = generateUserId();
      } while (users.some(user => user.id === newId));
      
      user = {
        id: newId,
        username: `用户${phone.substring(7)}`, // 使用手机号后4位作为默认用户名
        phone,
        password: generateVerificationCode(), // 生成随机密码
        avatar: DEFAULT_AVATAR,
        exp: 0,
        deviceId,
        birthday: '',
        bio: '',
        mbti: ''
      };
      
      users.push(user);
      localStorage.setItem(USERS_KEY, JSON.stringify(users));
    }
    
    // 创建认证数据并存储
    const authData = {
      id: user.id,
      username: user.username,
      avatar: user.avatar,
      exp: user.exp || 0,
      birthday: user.birthday || '',
      bio: user.bio || '',
      mbti: user.mbti || '',
      isLoggedIn: true
    };
    
    localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    return authData;
  },
  
  // 使用手机号和密码登录
  loginWithPhonePassword: (phone, password) => {
    // 验证手机号格式
    validatePhone(phone);
    
    // 查找用户
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const user = users.find(u => u.phone === phone && u.password === password);
    
    if (!user) {
      throw new Error('手机号或密码错误');
    }
    
    // 创建认证数据并存储
    const authData = {
      id: user.id,
      username: user.username,
      avatar: user.avatar,
      exp: user.exp || 0,
      birthday: user.birthday || '',
      bio: user.bio || '',
      mbti: user.mbti || '',
      isLoggedIn: true
    };
    
    localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    return authData;
  },

  // 添加一个方法来重新生成所有用户的ID
  regenerateAllUserIds: () => {
    const users = JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
    const usedIds = new Set();
    
    // 为每个用户生成新的唯一ID
    users.forEach(user => {
      let newId;
      do {
        newId = generateUserId();
      } while (usedIds.has(newId));
      
      usedIds.add(newId);
      user.id = newId;
    });
    
    localStorage.setItem(USERS_KEY, JSON.stringify(users));
    
    // 更新当前登录用户的ID
    const currentUser = JSON.parse(localStorage.getItem(AUTH_KEY));
    if (currentUser) {
      const updatedUser = users.find(u => u.username === currentUser.username);
      if (updatedUser) {
        currentUser.id = updatedUser.id;
        localStorage.setItem(AUTH_KEY, JSON.stringify(currentUser));
      }
    }
  }
};

// 添加通知相关的服务
export const notificationService = {
  // 检查是否有新通知
  checkNotifications: () => {
    // 这里可以连接后端API
    // 暂时返回模拟数据
    return Promise.resolve(true);
  },

  // 标记通知为已读
  markAsRead: () => {
    // 这里可以连接后端API
    return Promise.resolve(true);
  }
};

// 导出 DEFAULT_AVATAR 常量
export { DEFAULT_AVATAR };